export enum RegexesEnum {
    IgnoreCaseFlag = 'i',
    GlobalSearchFlag = 'g',
    MultilineFlag = 'm',
    UnicodeFlag = 'u',
    StickyFlag = 'y',
    DoToAllFlag = 's',

    NamePatternRegex = '^(?=.*[A-Z]|[a-z]|[0-9])([A-Za-z0-9.\\s_-]+)$',
    NoNumbersInStringPatternRegex = '^[^0-9]*$',
    AnyWordCharPatternRegex = '\w*',
    UrlPatternRegex = '^[^A-Z\\t ]*$',
    NumberPatternRegex = '^[0-9]+$',
    PartnerGroupNamePatternRegex = '[a-zA-Z0-9+_@.-]*$',
    MobileNumberPatternRegex = '^[\+][(]?[0-9]{3}[)]?[0-9]{2,16}$',
}
